import React, { CSSProperties } from 'react';

import { IconButton } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseButton from '@material-ui/icons/Close';
import clsx from 'clsx';

import { useStyles } from './style';
import { ThemedButton } from '../themed-button';

interface Props {
  title: string | React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  onClose?: () => void;
  customClass?: string;
  style?: CSSProperties;
  skipContinueText?: boolean;
  continueText?: string;
  redMode?: boolean;
  alertMode?: boolean;
  hideCancelBtn?: boolean;
  hideOkBtn?: boolean;
  showThemedButton?: boolean,
}

export const Dialog: React.FC<Props> = React.memo(
  ({
    title,
    onConfirm,
    onCancel,
    customClass = '',
    style,
    skipContinueText,
    onClose,
    continueText = 'Do you want to continue?',
    redMode,
    alertMode,
    hideCancelBtn,
    hideOkBtn,
    showThemedButton,
  }) => {
    const classes = useStyles();
    return (
      <div>
        <div className={clsx([classes.root, customClass, redMode && classes.redMode, alertMode && classes.alertMode])} style={style}>
          <div className={classes.title}>{title}</div>
          {skipContinueText ? null : <div className={classes.confirmText}>{continueText}</div>}
          <div className={classes.actions}>
            {!hideOkBtn && <IconButton onClick={onConfirm} className={clsx(classes.confirmBtn, alertMode && classes.confirmBtnAlert)}>
              <CheckIcon />
            </IconButton>}
            {!hideCancelBtn && <IconButton onClick={onCancel} className={clsx(classes.cancelBtn, redMode && classes.cancelBtnRed, alertMode && classes.cancelBtnAlert)}>
              <CloseButton />
            </IconButton>}
            {showThemedButton && <ThemedButton
                title='Close'
                onClick={onClose || onCancel}
                isSmall={true}
                width={70}
              />}
          </div>
        </div>
        <div className={clsx(classes.overlay, alertMode && classes.overlayAlert)} onClick={onClose || onCancel} />
      </div>
    );
  },
);
